enum RequestStatus {
  NotStarted = 0,
  Pending = 1,
  Success = 2,
  Failed = 3
}

export default RequestStatus;
